import { render, staticRenderFns } from "./edit-role.vue?vue&type=template&id=c67b6934"
import script from "./edit-role.vue?vue&type=script&lang=ts"
export * from "./edit-role.vue?vue&type=script&lang=ts"
import style0 from "./edit-role.vue?vue&type=style&index=0&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports